import { render } from "./Projects.vue?vue&type=template&id=04b6ea3d&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=04b6ea3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04b6ea3d"]])

export default __exports__